export const INGREDIENT_LIBRARY_PAGE_REQUEST =
  'INGREDIENT_LIBRARY_PAGE_REQUEST';
export const INGREDIENT_LIBRARY_LIST_ITEM_REQUEST =
  'INGREDIENT_LIBRARY_LIST_ITEM_REQUEST';
export const INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST =
  'INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST';
export const INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST =
  'INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST';
export const INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN =
  'INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN';
export const INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN =
  'INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN';
export const INGREDIENT_LIBRARY_SET_CATEGORY_LIST =
  'INGREDIENT_LIBRARY_SET_CATEGORY_LIST';
export const INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID =
  'INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID';
export const INGREDIENT_LIBRARY_SET_ITEM_LIST =
  'INGREDIENT_LIBRARY_SET_ITEM_LIST';
export const INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID =
  'INGREDIENT_LIBRARY_SET_CURRENT_ITEM_ID';
export const INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID =
  'INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID';
export const INGREDIENT_LIBRARY_SET_ITEM_SUMMARY =
  'INGREDIENT_LIBRARY_SET_ITEM_SUMMARY';
export const INGREDIENT_LIBRARY_SET_OUTLETS = 'INGREDIENT_LIBRARY_SET_OUTLETS';
export const INGREDIENT_LIBRARY_SET_FILTER_STATE =
  'INGREDIENT_LIBRARY_SET_FILTER_STATE';
export const INGREDIENT_LIBRARY_SET_FILTER_ITEM =
  'INGREDIENT_LIBRARY_SET_FILTER_ITEM';
export const INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS =
  'INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS';
export const INGREDIENT_LIBRARY_SET_CURRENT_PAGE =
  'INGREDIENT_LIBRARY_SET_CURRENT_PAGE';
export const INGREDIENT_LIBRARY_SET_TOTAL_PAGE =
  'INGREDIENT_LIBRARY_SET_TOTAL_PAGE';
export const INGREDIENT_LIBRARY_ITEMS_REQUEST =
  'INGREDIENT_LIBRARY_ITEMS_REQUEST';
export const INGREDIENT_LIBRARY_UNSET_FILTER_STATE =
  'INGREDIENT_LIBRARY_UNSET_FILTER_STATE';
export const INGREDIENT_LIBRARY_ITEM_LIST_EXPORT =
  'INGREDIENT_LIBRARY_ITEM_LIST_EXPORT';
export const INGREDIENT_LIBRARY_SET_TYPE_IMPORT =
  'INGREDIENT_LIBRARY_SET_TYPE_IMPORT';
export const INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER =
  'INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER';
export const INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN =
  'INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN';
export const INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN =
  'INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN';
export const INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM =
  'INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM';
export const INGREDIENT_LIBRARY_SET_ITEM_DETAIL =
  'INGREDIENT_LIBRARY_SET_ITEM_DETAIL';
export const INGREDIENT_LIBRARY_ON_CLICK_CANCEL =
  'INGREDIENT_LIBRARY_ON_CLICK_CANCEL';
export const INGREDIENT_LIBRARY_ON_CLICK_ROW =
  'INGREDIENT_LIBRARY_ON_CLICK_ROW';
export const INGREDIENT_LIBRARY_ON_DROP_IMAGE =
  'INGREDIENT_LIBRARY_ON_DROP_IMAGE';
export const INGREDIENT_LIBRARY_ON_DELETE_IMAGE =
  'INGREDIENT_LIBRARY_ON_DELETE_IMAGE';
export const INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT =
  'INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT';
export const INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL =
  'INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL';
export const INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL =
  'INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL';
export const INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM =
  'INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM';
export const INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL =
  'INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL';
export const INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL =
  'INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL';
export const INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL =
  'INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL';
export const INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL =
  'INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL';
export const INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING =
  'INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING';
export const INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL =
  'INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL';
export const INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL =
  'INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL';
export const INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM =
  'INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM';
export const INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM =
  'INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM';
export const INGREDIENT_LIBRARY_SET_MODIFIERS =
  'INGREDIENT_LIBRARY_SET_MODIFIERS';
export const INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS =
  'INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS';
export const INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY =
  'INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY';
export const INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE = `INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE`;
export const INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE = `INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE`;
export const INGREDIENT_LIBRARY_SHOW_DELETE_MODAL = `INGREDIENT_LIBRARY_SHOW_DELETE_MODAL`;
export const INGREDIENT_LIBRARY_HIDE_DELETE_MODAL = `INGREDIENT_LIBRARY_HIDE_DELETE_MODAL`;
export const INGREDIENT_LIBRARY_DELETE_ITEM = `INGREDIENT_LIBRARY_DELETE_ITEM`;
export const INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY = `INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY`;
export const INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL = `INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL`;
export const INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL = `INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL`;
export const INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY = `INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY`;
export const INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY = `INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY`;
export const INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES = `INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES`;
export const INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID = `INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID`;
export const INGREDIENT_LIBRARY_SET_NEW_CATEGORY = `INGREDIENT_LIBRARY_SET_NEW_CATEGORY`;
export const INGREDIENT_LIBRARY_SET_UNITS = 'INGREDIENT_LIBRARY_SET_UNITS';
export const INGREDIENT_LIBRARY_SET_UNCATEGORIZED =
  'INGREDIENT_LIBRARY_SET_UNCATEGORIZED';
export const INGREDIENT_LIBRARY_STORE_UNCATEGORIZED =
  'INGREDIENT_LIBRARY_STORE_UNCATEGORIZED';
export const INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL =
  'INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL';
export const INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL =
  'INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL';
export const INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT =
  'INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT';
export const INGREDIENT_LIBRARY_SHOW_COGS_MODAL =
  'INGREDIENT_LIBRARY_SHOW_COGS_MODAL';
export const INGREDIENT_LIBRARY_HIDE_COGS_MODAL =
  'INGREDIENT_LIBRARY_HIDE_COGS_MODAL';
export const INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS =
  'INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS';
export const INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL =
  'INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL';
export const INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL =
  'INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL';
export const INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL =
  'INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL';
export const INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL =
  'INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL';
export const INGREDIENT_LIBRARY_SET_CREATED_OUTLETS =
  'INGREDIENT_LIBRARY_SET_CREATED_OUTLETS';
export const INGREDIENT_LIBRARY_SHOW_INPUT_COGS =
  'INGREDIENT_LIBRARY_SHOW_INPUT_COGS';
export const INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY =
  'INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY';
export const INGREDIENT_LIBRARY_IS_SUBMITTING_FORM =
  'INGREDIENT_LIBRARY_IS_SUBMITTING_FORM';
export const INGREDIENT_LIBRARY_EXPORT_START = `INGREDIENT_LIBRARY_EXPORT_START`;
export const INGREDIENT_LIBRARY_EXPORT_DONE = `INGREDIENT_LIBRARY_EXPORT_DONE`;
export const INGREDIENT_LIBRARY_EXPORT_FAILED = `INGREDIENT_LIBRARY_EXPORT_FAILED`;
export const INGREDIENT_LIBRARY_SET_ASYNCJOBID = `INGREDIENT_LIBRARY_SET_ASYNCJOBID`;
export const INGREDIENT_LIBRARY_SET_EXPORTING_INGREDIENT = `INGREDIENT_LIBRARY_SET_EXPORTING_INGREDIENT`;
